import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { omit } from 'lodash'
import { FormattedMessage, FormattedDate, injectIntl, intlShape } from 'react-intl';

import { callApi } from '../services/fetchService'
import { getSelectOptions } from '../services/selectService'
import { loadGlobals } from '../actions'

import FaIcon from '../components/FaIcon'
import Badge from '../components/Badge'
import { Row, Col, Card, Form, Input, Button, Divider, Switch, Select, Spin, List, message } from 'antd'
const FormItem = Form.Item



/**
 * Profile form inside the view
 */

class _ProfileForm extends Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { intl } = this.props

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }
        const tailFormItemLayout = {
            wrapperCol: { offset: 6, span: 18 },
            style: { marginTop: '25px' }
        }
        
        return (
            <Form layout="horizontal" onSubmit={this.handleSubmit}>
                <FormItem label={<FormattedMessage id="user.firstName" />} {...formItemLayout}>
                    {getFieldDecorator('firstName', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.firstNameRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.lastName" />} {...formItemLayout}>
                    {getFieldDecorator('lastName', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.lastNameRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="user.addressStreet" />} {...formItemLayout}>
                    {getFieldDecorator('addressStreet', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.addressStreetRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.addressNumber" />} {...formItemLayout}>
                    {getFieldDecorator('addressNumber', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.addressNumberRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.addressZip" />} {...formItemLayout}>
                    {getFieldDecorator('addressZip', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.addressZipRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.addressCity" />} {...formItemLayout}>
                    {getFieldDecorator('addressCity', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.addressCityRequired'})}]
                    })(<Input/>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.addressCountry" />} {...formItemLayout}>
                    {getFieldDecorator('addressCountry', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.addressCountryRequired'})}]
                    })(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {getSelectOptions('country', this.props.user.addressCountry)}
                    </Select>)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="user.mobile" />} {...formItemLayout}>
                    {getFieldDecorator('mobile', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.mobileRequired'})}]
                    })(<Input addonBefore={<FaIcon icon="mobile" fixedWidth />} />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.phone" />} {...formItemLayout}>
                    {getFieldDecorator('phone', {
                    })(<Input addonBefore={<FaIcon icon="phone" fixedWidth />} />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.fax" />} {...formItemLayout}>
                    {getFieldDecorator('fax', {
                    })(<Input addonBefore={<FaIcon icon="fax" fixedWidth />} />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.email" />} {...formItemLayout}>
                    {getFieldDecorator('email', {
                        rules: [
                            {type: 'email', message: intl.formatMessage({id: 'user.wrongEmail'})},
                            {required: true, message: intl.formatMessage({id: 'user.emailRequired'})}
                        ]
                    })(<Input addonBefore={<FaIcon icon="envelope" fixedWidth />} />)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="user.language" />} {...formItemLayout}>
                    {getFieldDecorator('language', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.languageRequired'})}]
                    })(<Select showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {getSelectOptions('language', this.props.user.language)}
                    </Select>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.permissions" />} {...formItemLayout}>
                    {getFieldDecorator('permissions', {
                        rules: [{required: true, message: intl.formatMessage({id: 'user.permissionsRequired'})}]
                    })(<Select showSearch mode="multiple" optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {getSelectOptions('permission', this.props.user.permissions)}
                    </Select>)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.showHelp" />} {...formItemLayout}>
                    {getFieldDecorator('showHelp', {
                        valuePropName: 'checked'
                    })(<Switch />)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="user.password" />} {...formItemLayout} help={<FormattedMessage id="user.passwordHelp" />}>
                    {getFieldDecorator('password', {
                        rules: [{required: true}]
                    })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} type="password" />)}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" loading={this.props.updating} htmlType="submit"><FormattedMessage id="misc.save" /></Button>
                </FormItem>
            </Form>
        )
    }

}

const ProfileForm = injectIntl(Form.create({
    mapPropsToFields(props) {
        return {
            firstName: Form.createFormField({value: props.user.firstName}),
            lastName: Form.createFormField({value: props.user.lastName}),
            addressStreet: Form.createFormField({value: props.user.addressStreet}),
            addressNumber: Form.createFormField({value: props.user.addressNumber}),
            addressZip: Form.createFormField({value: props.user.addressZip}),
            addressCity: Form.createFormField({value: props.user.addressCity}),
            addressCountry: Form.createFormField({value: props.user.addressCountry}),
            mobile: Form.createFormField({value: props.user.mobile}),
            phone: Form.createFormField({value: props.user.phone}),
            fax: Form.createFormField({value: props.user.fax}),
            email: Form.createFormField({value: props.user.email}),
            language: Form.createFormField({value: props.user.language}),
            permissions: Form.createFormField({value: props.user.permissions}),
            showHelp: Form.createFormField({value: props.user.showHelp})
        };
    }
})(_ProfileForm))



/**
 * Change password form
 */
class _ChangePasswordForm extends Component {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }

    confirmDirty = false
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSubmit(omit(values, ['confirmPassword']))
            }
        })
    }

    handleConfirmBlur = (e) => {
        this.confirmDirty = this.confirmDirty || !!e.target.value
    }

    checkConfirm = (rule, value, callback) => {
        const form = this.props.form
        if (value && this.confirmDirty) {
            form.validateFields(['confirmPassword'], { force: true })
        }
        callback()
    }

    checkPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('newPassword')) {
            callback(this.props.intl.formatMessage({id: 'user.passwordDoNotMatch'}))
        } else {
            callback()
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { intl } = this.props

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }
        const tailFormItemLayout = {
            wrapperCol: { offset: 6, span: 18 }
        }
        
        return (
            <Form layout="horizontal" onSubmit={this.handleSubmit}>
                <FormItem label={<FormattedMessage id="user.newPassword" />} {...formItemLayout}>
                    {getFieldDecorator('newPassword', {
                        rules: [
                            {required: true, message: intl.formatMessage({id: 'user.newPasswordRequired'})},
                            {validator: this.checkConfirm}
                        ]
                    })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} type="password" />)}
                </FormItem>
                <FormItem label={<FormattedMessage id="user.confirmPassword" />} {...formItemLayout}>
                    {getFieldDecorator('confirmPassword', {
                        rules: [
                            {required: true, message: intl.formatMessage({id: 'user.confirmPasswordRequired'})},
                            {validator: this.checkPassword}
                        ]
                    })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} onBlur={this.handleConfirmBlur} type="password" />)}
                </FormItem>
                <Divider />
                <FormItem label={<FormattedMessage id="user.password" />} {...formItemLayout} help={<FormattedMessage id="user.passwordHelp" />}>
                    {getFieldDecorator('password', {
                        rules: [
                            {required: true, message: intl.formatMessage({id: 'user.passwordRequired'})}
                        ]
                    })(<Input addonBefore={<FaIcon icon="lock" fixedWidth />} type="password" />)}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" loading={this.props.updating} htmlType="submit"><FormattedMessage id="user.changePasswordButton" /></Button>
                </FormItem>
            </Form>
        )
    }

}

const ChangePasswordForm = injectIntl(Form.create()(_ChangePasswordForm))



/**
 * User view
 */

class User extends Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        loadGlobals: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        userId: null,
        user: null,
        formUser: null,
        loading: false,
        updating: false
    }

    fetch = () => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'users/' + this.state.userId
        }).then((data) => {
            this.setState({
                user: data,
                formUser: Object.assign({}, data),
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userId !== nextProps.match.params.id) {
            this.setState({ userId: nextProps.match.params.id }, this.fetch)
        }
    }

    componentWillMount() {
        this.setState({ userId: this.props.match.params.id })
    }

    componentDidMount() {
        this.fetch()
    }

    updateUser = (user) => {
        const { intl } = this.props
        this.setState({
            formUser: Object.assign({}, this.state.formUser, user),
            updating: true
        })
        callApi({
            endpoint: 'users/' + this.state.userId,
            body: user,
            method: 'POST'
        }).then((data) => {
            this.setState({
                user: data,
                formUser: Object.assign({}, data),
                updating: false
            })
            message.success(this.props.intl.formatMessage({id: "misc.updateSuccess"}))
            this.props.loadGlobals()
        }).catch((err) => {
            console.log(err);
            if (err.status === 401) {
                message.error(intl.formatMessage({id: 'user.invalidPassword'}))
            } else if (err.code === 11) {
                message.warn(intl.formatMessage({id: 'user.unableToSelfUpdate'}))
            } else {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
            }
            this.setState({ updating: false })
        })
    }

    changePassword = ({ password, newPassword }) => {
        const { intl } = this.props
        this.setState({ updating: true })
        callApi({
            endpoint: 'users/' + this.state.userId,
            body: { password: password, newPassword },
            method: 'POST'
        }).then((data) => {
            this.setState({ updating: false })
            message.success(this.props.intl.formatMessage({id: "misc.updateSuccess"}))
        }).catch((err) => {
            if (err.status === 401) {
                message.error(intl.formatMessage({id: 'user.invalidPassword'}))
            } else {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
            }
            this.setState({ updating: false })
        })
    }

    render() {
        const { user, loading, updating, formUser } = this.state
      
		if (!user || loading) {
			return (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin size="large" />
                </div>
            )
        }

        const isDoctor = user.permissions.indexOf('doctor') !== -1
        
        return (
            <div>
                {
                    isDoctor ? <h1><FaIcon icon="user-md" fixedWidth /><FormattedMessage id="user.titleDoctor" values={user} /></h1>
                    : <h1><FaIcon icon="user" fixedWidth /> <FormattedMessage id="user.titleUser" values={user} /></h1>
                }
                <Row gutter={24}>
                    <Col lg={14}>
                        <Card title={<span><FaIcon icon="info-circle" /><FormattedMessage id="user.identification" /></span>}>
                            <ProfileForm user={formUser} onSubmit={this.updateUser} updating={updating} />
                        </Card>
                    </Col>
                    <Col lg={10}>
                        <Card title={<span><FaIcon icon="chart-bar" /><FormattedMessage id="user.statistics" /></span>}>
                            <List itemLayout="horizontal" className="statistics">
                                <List.Item><FormattedMessage id="user.numberOfPatients" /><Badge>{user.numberOfPatients}</Badge></List.Item>
                                <List.Item><FormattedMessage id="user.numberOfConsultations" /><Badge>{user.numberOfConsultations}</Badge></List.Item>
                                <List.Item><FormattedMessage id="user.numberOfBloodTests" /><Badge>{user.numberOfBloodTests}</Badge></List.Item>
                                <List.Item><FormattedMessage id="user.registeredSince" /><Badge><FormattedDate value={user.registrationDate}/></Badge></List.Item>
                                <List.Item><FormattedMessage id="user.lastConsultation" /><Badge>{user.lastConsultation ? <FormattedDate value={user.lastConsultation}/> : '-'}</Badge></List.Item>
                            </List>
                        </Card>
                    </Col>
                    <Col lg={14}>
                        <Card title={<span><FaIcon icon="lock" /><FormattedMessage id="user.changePassword" /></span>}>
                            <ChangePasswordForm onSubmit={this.changePassword} updating={updating} />
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }

}

export default injectIntl(withRouter(connect(null, {
    loadGlobals
})(User)))


// WEBPACK FOOTER //
// ./src/views/User.js